export default __webpack_public_path__ + "static/media/pfp 6 1-min.5b54b6de.png";